export class Task {
    constructor(
            data={
                id:-1, 
                object_type:'', 
                content:'', 
                start_date:'', 
                end_date:''
            }) {
        this.id = data.id;
        this.object_type = data.object_type;
        this.content = data.content;
        this.start_date = data.start_date;
        this.end_date = data.end_date;
    }

    getId() {
        return this.id;
    }

    getObjectType() {
        return this.object_type;
    }

    getContent() {
        return this.content;
    }

    getStartDate() {
        return this.start_date;
    }

    getEndDate() {
        return this.end_date;
    }
}